import {useEffect, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Skeleton} from '@mui/material';
import {Stack} from '@mui/material';
import {useTranslation} from "react-i18next";

am4core.useTheme(am4themes_animated);

const ChartOne = ({data, name, className}) => {
    const [showLoader, setShowLoader] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        chart.cursor = new am4charts.XYCursor();
        chart.scrollbarX = new am4core.Scrollbar();

        let chartData = data['data'];
        let legend = data['legend'];

        // Add data
        chart.data = chartData;

        // Create X-axis (category axis)
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.minGridDistance = 15;

        // Create Y-axis for the lines (value axis)
        let lineAxis = chart.yAxes.push(new am4charts.ValueAxis());
        lineAxis.min = 0;
        lineAxis.extraMax = 0.20;
        lineAxis.strictMinMax = true;// Moves the line axis to the opposite side
        lineAxis.tooltip.disabled = true;
        lineAxis.numberFormatter = new am4core.NumberFormatter();
        lineAxis.numberFormatter.numberFormat = "#'%'";
        lineAxis.renderer.minGridDistance = 20;
        lineAxis.renderer.grid.template.disabled = true; // Hide grid lines

        // Create series for line_1
        let lineSeries1 = chart.series.push(new am4charts.LineSeries());
        lineSeries1.dataFields.valueY = "own_local_revenue_divided_by_public_revenue";
        lineSeries1.dataFields.categoryX = "year";
        lineSeries1.yAxis = lineAxis;
        lineSeries1.name = legend['own_local_revenue_divided_by_public_revenue'];
        lineSeries1.stroke = am4core.color("#d42daa");
        lineSeries1.strokeWidth = 2;
        lineSeries1.tooltipText = "{name}: [bold]{valueY}[/]";
        lineSeries1.tooltip.getFillFromObject = false;
        lineSeries1.tooltip.background.fill = am4core.color("#d42daa");

        let bullet = lineSeries1.bullets.push(new am4charts.CircleBullet());
        bullet.circle.radius = 6;
        bullet.circle.stroke = am4core.color("#d42daa");
        bullet.circle.fill = am4core.color("#d42daa");
        bullet.circle.strokeWidth = 2;

        let label1 = bullet.createChild(am4core.Label);
        label1.stroke = am4core.color("#000");
        label1.text = "{valueY}%";
        label1.horizontalCenter = "middle";
        label1.verticalCenter = "bottom";
        label1.dy = -10;
        label1.fontWeight = 'lighter';

        // Create series for line_2
        let lineSeries2 = chart.series.push(new am4charts.LineSeries());
        lineSeries2.dataFields.valueY = "own_local_revenue_divided_by_gdp";
        lineSeries2.dataFields.categoryX = "year";
        lineSeries2.yAxis = lineAxis;
        lineSeries2.name = legend['own_local_revenue_divided_by_gdp'];
        lineSeries2.strokeWidth = 2;
        lineSeries2.tooltipText = "{name}: [bold]{valueY}[/]";

        let bullet2 = lineSeries2.bullets.push(new am4charts.CircleBullet());
        bullet2.circle.radius = 6;
        bullet2.circle.strokeWidth = 2;

        let label2 = bullet2.createChild(am4core.Label);
        label2.stroke = am4core.color("#000");
        label2.text = "{valueY}%";
        label2.horizontalCenter = "middle";
        label2.verticalCenter = "bottom";
        label2.dy = -10;
        label2.fontWeight = 'lighter';

        // Add legend
        chart.legend = new am4charts.Legend();

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.menu.align = 'left';
        chart.exporting.menu.verticalAlign = 'top';

        // Add cursor
        chart.cursor = new am4charts.XYCursor();
    }, []);


    return (
        <>
            <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            {showLoader && (
                <Stack spacing={1}>
                    <Skeleton variant='text'/>
                    <Skeleton variant='rounded' width={'auto'} height={500}/>
                </Stack>
            )}
        </>
    );
};

export default ChartOne;
